import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { checkStatus, setLoader } from '../../../../util/util';
import ModalManageDevice from '../../../Modals/ModalManageDevice';
import AlertBar from '../../../Modals/AlertBar';
import { AlertConfirm, AlertCommit, Alert } from '../../../Modals/AlertBar';
import FileBase64 from 'react-file-base64';
import './SpecialConfigCSS.css';
import Select from 'react-select';

let fileName = '';
let content = '';
class SpecialConfig extends Component {

    constructor() {
        super();

        this.state = {

            is_send_dlt: false,
            is_send_scg: false,
            is_send_ambulance: false,
            is_send_sccc: false,
            is_send_post_office: false,
            dlt_group: 0,
            file_name: '',
            file_attach: '',
            change_detail: '',
            inform_date: moment(),
            car_type_id: 0,
            car_no: '',
            car_province: '',
            car_brand: '',
            chassis: '',
            company: '',
            dlt_card_no: '',
            db_card_no: '',
            fix_place: '',
            fix_place_start_date: moment(),
            fix_place_finish_date: moment(),
            carTypeList: [],
            provinceList: [],
            carBrandList: [],
            carType: '',
            province: '',
            carBrand: '',
            showModalConfirmManageDevice: false,
            notification: false,
            selectedFile: null, loaded: 0,
            fileName: '',
            content: '',
            attachDoc: [],
            attachOff: [],
            isClearable: true,
            isDisabled: false,
            isLoading: false,
            isRtl: false,
            isSearchable: true,
            selectedCar: null,
            unit_id: '',
        };
    }

    componentWillMount() {


    }


    componentDidMount() {
        this.getCarTypeList();
        this.getProvinceList();
        this.getCarBrandList();
        this.getDeviceAttachNames();
        this.getDeviceAttachNamesOffline();
    }

    componentWillUnmount() {

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.specialSetting !== this.props.specialSetting) {

            let specialSetting = nextProps.specialSetting;

            let informDate = null;
            if (specialSetting.inform_date !== null && specialSetting.inform_date !== undefined && specialSetting.inform_date !== "")
                informDate = moment(this.changeformatDate(specialSetting.inform_date));

            let fixPlaceStartDate = null;
            if (specialSetting.fix_place_start_date !== null && specialSetting.fix_place_start_date !== undefined && specialSetting.fix_place_start_date !== "")
                fixPlaceStartDate = moment(this.changeformatDate(specialSetting.fix_place_start_date));

            let fixPlaceFinishDate = null;
            if (specialSetting.fix_place_finish_date !== null && specialSetting.fix_place_finish_date !== undefined && specialSetting.fix_place_finish_date !== "")
                fixPlaceFinishDate = moment(this.changeformatDate(specialSetting.fix_place_finish_date));

            this.setState({
                is_send_dlt: specialSetting.is_send_dlt,
                is_send_scg: specialSetting.is_send_scg,
                is_send_ambulance: specialSetting.is_send_ambulance,
                is_send_sccc: specialSetting.is_send_sccc,
                is_send_post_office: specialSetting.is_send_post_office,
                dlt_group: specialSetting.dlt_group,
                file_name: specialSetting.file_name,
                file_attach: specialSetting.file_attach,
                change_detail: specialSetting.change_detail,
                inform_date: informDate,
                car_type_id: specialSetting.car_type_id,
                car_no: specialSetting.car_no,
                car_province: specialSetting.car_province,
                car_brand: specialSetting.car_brand,
                selectedCar: { label: specialSetting.car_brand, value: specialSetting.car_brand },
                chassis: specialSetting.chassis,
                company: specialSetting.company,
                dlt_card_no: specialSetting.dlt_card_no,
                db_card_no: specialSetting.db_card_no,
                fix_place: specialSetting.fix_place,
                fix_place_start_date: fixPlaceStartDate,
                fix_place_finish_date: fixPlaceFinishDate,
                unit_id: nextProps.unit_id
            });

        }
    }

    getCarTypeList() {

        const { user_id, user_name, token } = this.props;

        fetch(`http://203.150.199.244/api/admin/getCarTypeList`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                // "filter":deviceSearch
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {

                let carList = [];
                data.RESULT_DATA.map((carType, key) => {

                    carList.push({
                        car_type_id: carType.car_type_id,
                        car_type: carType.car_type,
                    });

                });
                this.setCarTypeList(carList);
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    setCarTypeList(data) {
        this.setState({
            carTypeList: data
        });
    }

    getProvinceList() {

        const { user_id, user_name, token } = this.props;
        fetch(`http://203.150.199.244/api/admin/getProvinceList`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                // "filter":deviceSearch
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {

                let provinceList = [];
                data.RESULT_DATA.map((privince, key) => {

                    provinceList.push({
                        name_t: privince.name_t,
                        name_e: privince.name_e,
                        code: privince.code,
                    });

                });
                this.setProvinceList(provinceList);

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    setProvinceList(data) {

        this.setState({
            provinceList: data
        });
    }

    getCarBrandList() {

        const { user_id, user_name, token } = this.props;

        fetch(`http://203.150.199.244/api/admin/getCarBrandList`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                // "filter":deviceSearch
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {

                let brandList = [];
                data.RESULT_DATA.map((brand, key) => {

                    brandList.push({
                        _id: brand._id,
                        name: brand.name,
                    });

                });
                this.setCarBrandList(brandList);
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    setCarBrandList(data) {

        this.setState({
            carBrandList: data
        });
    }

    handleChangeIsSendDlt = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            is_send_dlt: value
        });
    }

    handleChangeIsSendScg = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            is_send_scg: value
        });
    }

    handleChangeIsSendAmbulance = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            is_send_ambulance: value
        });
    }

    handleChangeIsSendSccc = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            is_send_sccc: value
        });
    }

    handleChangeIsSendPosOffice = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            is_send_post_office: value
        });
    }

    handleChangeInformlDate = (date) => {
        this.setState({
            inform_date: date
        });

    }

    handleChangeStartDate = (date) => {
        this.setState({
            fix_place_start_date: date
        });

    }

    handleChangeFinishDate = (date) => {
        this.setState({
            fix_place_finish_date: date
        });

    }

    changeformatDate(date) {

        let str = date.split("-");
        return str[2] + '-' + str[1] + '-' + str[0];
    }

    dateWrapper(rDate) {

        let rDateWrapper = rDate;
        if (rDate != null && rDate.toObject().years > 2500) {
            rDateWrapper = moment((rDate.toObject().years - 543) + '-' + rDate.toObject().months + '-' + rDate.toObject().date);
        }
        return rDateWrapper;
    }

    handleChangeRadio = (e) => {
        this.setState({
            dlt_group: e.target.value
        });
    }

    // onClickUpdate = () => {

    //     this.setState({
    //         showModalConfirmManageDevice:true,
    //     });

    // }

    convertMomentToString(moment) {

        if (moment) {
            let date = moment.toObject().date;
            let months = moment.toObject().months;
            let years = moment.toObject().years;

            months = months + 1;
            if (date.toString().length == 1) {
                date = '0' + date;
            }
            if (months.toString().length == 1) {
                months = '0' + months;
            }
            return date + '-' + months + '-' + years;
        }


    }

    onClickUpdate = () => {

        AlertConfirm("แก้ไขการตั้งค่าพิเศษ", " ").then(isOk => {
            if (isOk) {
                const {
                    user_name,
                    user_id,
                    sideBarName,
                    deviceId,
                    token
                } = this.props;
                const { dataCreateNewUser, deviceSelect, manageDevice, petroleum_from_date, petroleum_to_date,
                    is_send_dlt,
                    is_send_scg,
                    is_send_ambulance,
                    is_send_sccc,
                    is_send_post_office,
                    dlt_group,
                    file_name,
                    file_attach,
                    change_detail,
                    inform_date,
                    car_type_id,
                    car_no,
                    car_province,
                    car_brand,
                    chassis,
                    company,
                    dlt_card_no,
                    db_card_no,
                    fix_place,
                    fix_place_start_date,
                    fix_place_finish_date,
                } = this.state;
                console.log(car_province)
                console.log(car_brand)
                fetch(`http://203.150.199.244/api/admin/updateDevice/${deviceId}`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        // "user_id": user_id,
                        // "user_name": user_name,
                        "token": token,
                    },
                    body: JSON.stringify({
                        "special_setting": {
                            "is_send_dlt": is_send_dlt,
                            "is_send_scg": is_send_scg,
                            "is_send_ambulance": is_send_ambulance,
                            "is_send_sccc": is_send_sccc,
                            "is_send_post_office": is_send_post_office,
                            "dlt_group": dlt_group,
                            "file_name": file_name,
                            "file_attach": file_attach,
                            "change_detail": change_detail,
                            "inform_date": this.convertMomentToString(inform_date),
                            "car_type_id": car_type_id,
                            "car_no": car_no,
                            "car_province": car_province,
                            "car_brand": car_brand,
                            "chassis": chassis,
                            "company": company,
                            "dlt_card_no": dlt_card_no,
                            "db_card_no": db_card_no,
                            "fix_place": fix_place,
                            "fix_place_start_date": this.convertMomentToString(fix_place_start_date),
                            "fix_place_finish_date": this.convertMomentToString(fix_place_finish_date)
                        }
                    })
                })
                    .then(response => { return checkStatus(response) })
                    .then((data) => {

                        if (data.RESULT_STATUS == "000")
                            AlertCommit(true, "บันทึกข้อมูลเรียบร้อยแล้ว");
                        else {
                            AlertCommit(false, data.RESULT_STATUS + ": " + data.RESULT_MESSAGE);
                        }


                        this.setState({
                            showModalConfirmManageDevice: false,
                            // isShowCreateNewDealer: false,
                            // notification: true,

                        })
                        // if(response.RESULT_STATUS != '000'){
                        //     this.setState({
                        //         statusAlert:false,
                        //     });
                        // }
                    })
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });

            }

        });



    }

    onClickCancelManageDevice = (status) => {
        this.setState({ showModalConfirmManageDevice: status });
    }

    handleselectedFile = event => {
        console.log('event', event.target.files[0])
        let idCardBase64 = '';
        this.setState({
            selectedFile: event.target.files[0],
            loaded: 0,
        })


    }

    //   handleUpload = () => {
    //     const data = new FormData()
    //     data.append('file', this.state.selectedFile, this.state.selectedFile.name)
    //     console.log('data',data)
    //   }



    handleFileSelect(evt) {
        var files = evt.target.files;
        var file = files[0];

        var binaryString = '';
        var aa = '';
        const { user_id, user_name, token, deviceId } = this.props;
        if (files && file) {

            let sizeKb = file.size;
            let sizeMb = 1024 * 1014;
            let convertKbtoMb = sizeKb / sizeMb;

            if (file.size == 0) {
                // alert('ไฟล์มีขนาด 0 MB. กรุณาตรวจสอบไฟล์อัพโหลด')
                Alert('ไฟล์มีขนาด 0 MB. กรุณาตรวจสอบไฟล์อัพโหลด');
                files = null;
                file = null;
                return;
            }
            if (convertKbtoMb > 5) {
                // alert('This file is larger than 5 MB.')
                Alert('กรุณาเลือกไฟล์ ขนาดไฟล์ไม่เกิน 5 MB.');
                files = null;
                file = null;
                return;
            } else {
                console.log('else')
                var reader = new FileReader();

                reader.onload = (readerEvt) => {
                    binaryString = readerEvt.target.result;
                    // console.log(btoa(binaryString));
                    aa = btoa(binaryString);

                    fileName = file.name;
                    // fileName = fileName.split(' ').join('_');
                    // fileName = 'document'+this.dateWrapper( new Date());

                    fileName = btoa(unescape(encodeURIComponent(fileName)))
                    content = aa;
                    setLoader(true);
                    fetch(`http://203.150.199.244/api/admin/addDeviceAttach/${deviceId}/${'document'}`, {
                        method: 'post',
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            // "user_id": user_id,
                            // "user_name": user_name,
                            "token": token
                        },
                        body: JSON.stringify({
                            "name": fileName,
                            "content": aa
                        })
                    })
                        .then(response => { return checkStatus(response) })
                        .then(data => {
                            console.log(data)
                            if (data.RESULT_STATUS == "000")
                                this.getDeviceAttachNames();

                            setLoader(false);
                        })
                        .catch(function (err) {
                            console.log('err:', err);
                            setLoader(false);
                            // POST failed...
                        });
                }
                setLoader(false);
                reader.readAsBinaryString(file);

                // this.getDeviceAttachNames();
            }


        }

    }

    handleFileSelectOffline(evt) {
        var files = evt.target.files;
        var file = files[0];

        var binaryString = '';
        var aa = '';
        const { user_id, user_name, token, deviceId } = this.props;
        if (files && file) {

            let sizeKb = file.size;
            let sizeMb = 1024 * 1014;
            let convertKbtoMb = sizeKb / sizeMb;

            if (file.size == 0) {
                // alert('ไฟล์มีขนาด 0 MB. กรุณาตรวจสอบไฟล์อัพโหลด')
                Alert('ไฟล์มีขนาด 0 MB. กรุณาตรวจสอบไฟล์อัพโหลด');
                files = null;
                file = null;
                return;
            }
            if (convertKbtoMb > 5) {
                // alert('This file is larger than 5 MB.')
                Alert('กรุณาเลือกไฟล์ ขนาดไฟล์ไม่เกิน 5 MB.');
                files = null;
                file = null;
                return;
            } else {
                console.log('else')
                var reader = new FileReader();

                reader.onload = (readerEvt) => {
                    binaryString = readerEvt.target.result;
                    // console.log(btoa(binaryString));
                    aa = btoa(binaryString);

                    fileName = file.name;
                    // fileName = fileName.split(' ').join('_');

                    fileName = btoa(unescape(encodeURIComponent(fileName)))
                    content = aa;
                    console.log(deviceId)
                    setLoader(true);
                    fetch(`http://203.150.199.244/api/admin/addDeviceAttach/${deviceId}/${'offline'}`, {
                        method: 'post',
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            // "user_id": user_id,
                            // "user_name": user_name,
                            "token": token
                        },
                        body: JSON.stringify({
                            "name": fileName,
                            "content": aa
                        })
                    })
                        .then(response => { return checkStatus(response) })
                        .then(data => {
                            console.log(data)
                            if (data.RESULT_STATUS == "000")
                                this.getDeviceAttachNamesOffline();

                            setLoader(false);
                        })
                        .catch(function (err) {
                            console.log('err:', err);
                            // POST failed...
                            setLoader(false);
                        });
                };
                setLoader(false);
                reader.readAsBinaryString(file);

                // this.getDeviceAttachNames();
            }


        }

    }


    handleUpload() {

        console.log('content', content)
    }

    deleteAttachDocument(attName) {
        console.log(attName)
        AlertConfirm("ลบไฟล์อัพโหลด", " ").then(isOk => {
            if (isOk) {

                const { user_id, user_name, token, deviceId } = this.props;
                fetch(`http://203.150.199.244/api/admin/deleteDeviceAttach/${deviceId}/${attName}/${'document'}`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        // "user_id": user_id,
                        // "user_name": user_name,
                        "token": token
                    },
                    body: JSON.stringify({
                    })
                })
                    .then(response => { return checkStatus(response) })
                    .then(data => {
                        // console.log(data)


                        if (data.RESULT_STATUS == "000") {
                            AlertCommit(true, "ลบไฟล์อัพโหลดเรียบร้อยแล้ว");
                            this.getDeviceAttachNames();
                        } else {
                            AlertCommit(false, data.RESULT_STATUS + ": " + data.RESULT_MESSAGE);
                        }
                    })
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });
            }
        });

    }

    deleteAttachOffline(attName) {
        console.log(attName)
        AlertConfirm("ลบไฟล์อัพโหลด", " ").then(isOk => {
            if (isOk) {

                const { user_id, user_name, token, deviceId } = this.props;
                fetch(`http://203.150.199.244/api/admin/deleteDeviceAttach/${deviceId}/${attName}/${'offline'}`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        // "user_id": user_id,
                        // "user_name": user_name,
                        "token": token
                    },
                    body: JSON.stringify({
                    })
                })
                    .then(response => { return checkStatus(response) })
                    .then(data => {
                        // console.log(data)


                        if (data.RESULT_STATUS == "000") {
                            AlertCommit(true, "ลบไฟล์อัพโหลดเรียบร้อยแล้ว");
                            this.getDeviceAttachNamesOffline();
                        } else {
                            AlertCommit(false, data.RESULT_STATUS + ": " + data.RESULT_MESSAGE);
                        }
                    })
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });
            }
        });

    }

    getDeviceAttachNames() {

        const { user_id, user_name, token, deviceId } = this.props;
        console.log('getDeviceAttachNames', deviceId)
        fetch(`http://203.150.199.244/api/admin/getDeviceAttachNames/${deviceId}/${'document'}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {
                console.log('data.RESULT_DATA', data.RESULT_DATA)
                this.setState({
                    attachDoc: data.RESULT_DATA
                })
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
        console.log('end')
    }

    getDeviceAttachNamesOffline() {

        const { user_id, user_name, token, deviceId } = this.props;
        console.log('getDeviceAttachNamesOffline', deviceId)
        fetch(`http://203.150.199.244/api/admin/getDeviceAttachNames/${deviceId}/${'offline'}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {
                console.log('data.RESULT_DATA', data.RESULT_DATA)
                this.setState({
                    attachOff: data.RESULT_DATA
                })
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
        console.log('end')
    }

    getBase64(name) {
        console.log(name)
        let fileName = (new Buffer(name, 'base64')).toString();
        console.log(fileName)
        return fileName;

    }

    onSelectCar(obj) {

        if (obj) {
            this.setState({ car_brand: obj.value, selectedCar: obj })
        }

    }

    render() {

        const { specialSetting } = this.props;
        const {
            carTypeList,
            carBrandList,
            provinceList,
            carType,
            carBrand,
            is_send_dlt,
            is_send_scg,
            is_send_ambulance,
            is_send_sccc,
            is_send_post_office,
            dlt_group,
            file_name,
            file_attach,
            change_detail,
            inform_date,
            car_type_id,
            car_no,
            car_province,
            car_brand,
            chassis,
            company,
            dlt_card_no,
            db_card_no,
            fix_place,
            fix_place_start_date,
            fix_place_finish_date,
            showModalConfirmManageDevice,
            notification,
            isClearable,
            isSearchable,
            isDisabled,
            isLoading,
            isRtl,
            unit_id
        } = this.state;
        const select = [];
        carBrandList.map(car => {

            select.push({
                label: car.name,
                value: car.name,
            });
        });
        console.log('unit_idxxxx', unit_id)
        return (

            <div className="container-fluid">
                {/* { showModalConfirmManageDevice &&
                <ModalManageDevice
                    onClickCancelManageDevice={this.onClickCancelManageDevice}
                    onClickConfirmManageDevice={this.onUpdateSpecialSetting}
                />
            } */}
                {notification &&
                    <AlertBar status={this.state.statusAlert} />
                }
                <div className="card">
                    <h5 class="card-header">ตั้งค่าพิเศษ</h5>
                    <div class="card-body">


                        <label className="offset-md-1 col-md-3">
                            <input
                                type="checkbox"
                                checked={is_send_dlt}
                                onChange={this.handleChangeIsSendDlt} />
                            ข้อมูลส่งกรมขนส่งทางบก
                            </label>
                        <label className="col-md-2">
                            <input
                                type="checkbox"
                                checked={is_send_scg}
                                onChange={this.handleChangeIsSendScg} />
                            ข้อมูลส่ง SCG
                            </label>
                        <label className="col-md-2">
                            <input
                                type="checkbox"
                                checked={is_send_ambulance}
                                onChange={this.handleChangeIsSendAmbulance} />
                            ข้อมูลส่ง รถพยาบาล
                            </label>
                        <label className="col-md-2">
                            <input
                                type="checkbox"
                                checked={is_send_sccc}
                                onChange={this.handleChangeIsSendSccc} />
                            ข้อมูลส่ง SCCC
                            </label>
                        <label className="col-md-2">
                            <input
                                type="checkbox"
                                checked={is_send_post_office}
                                onChange={this.handleChangeIsSendPosOffice} />
                            ข้อมูลส่ง ไปรษณีย์
                            </label>
                        <hr />


                        <label className="offset-md-1 col-md-3">
                            <div>
                                กลุ่มรถ
                            </div>
                            <input
                                type="radio"
                                value={1}
                                name="dlt_group"
                                checked={this.state.dlt_group == 1}
                                onChange={this.handleChangeRadio}
                            />
                            [1] รถติดตั้งอุปกรณ์ใหม่
                            </label>
                        <label className="col-md-3">
                            <input
                                type="radio"
                                value={2}
                                name="dlt_group"
                                checked={this.state.dlt_group == 2}
                                onChange={this.handleChangeRadio}
                            />
                            [2] ติดตั้งก่อน 25/01/59
                            </label>
                        <label className="col-md-3">
                            <input
                                type="radio"
                                value={3}
                                name="dlt_group"
                                checked={this.state.dlt_group == 3}
                                onChange={this.handleChangeRadio}
                            />
                            [3] รถวัตถุอันตราย
                            </label>
                        <label className="col-md-2">
                            <input
                                type="radio"
                                value={99}
                                name="dlt_group"
                                checked={this.state.dlt_group == 99}
                                onChange={this.handleChangeRadio}
                            />
                            [99] ยกเลิก
                            </label>
                        <br />
                        <div className="control-label">
                            <label className="offset-1">Unit ID : {unit_id}</label>
                        </div>

                        <hr />

                        <div className="row">

                            <div className="col-md-6">
                                <form>
                                    <div className="form-group  row">
                                        <label className="col-md-4  col-form-label ">ประเภทรถ</label>
                                        <div className="form-group  col-md-8">
                                            <select className="form-control" value={this.state.car_type_id}
                                                onChange={(e) => this.setState({ car_type_id: e.target.value })}>
                                                {
                                                    carTypeList.map((item, key) => {

                                                        return (
                                                            // (item.first_name === device_driver) && 
                                                            <option key={key} selected={car_type_id == item.car_type_id} value={item.car_type_id}>{item.car_type}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-group  row">
                                        <label className="col-md-4  col-form-label ">จังหวัด</label>
                                        <div className="form-group  col-md-8">
                                            <select className="form-control" value={this.state.car_province} onChange={(e) => this.setState({ car_province: e.target.value })}>
                                                <option value="" >กรุณาเลือก</option>
                                                {
                                                    provinceList.map((item, key) => {

                                                        return (
                                                            // (item.first_name === device_driver) && 
                                                            <option key={key} selected={car_province == item.name_t} value={item.name_t}>{item.name_t}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-md-4  col-form-label ">ทะเบียนรถ</label>
                                        <div className="col-md-8" >
                                            <input
                                                className="form-control"
                                                type="text"
                                                id="userName"
                                                defaultValue={car_no}
                                                onChange={(e) => this.setState({ car_no: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group  row">
                                        <label className="col-md-4  col-form-label ">ยี่ห้อรถ</label>
                                        <div className="form-group  col-md-8">
                                            {/* <select className="form-control" value={this.state.car_brand} onChange={(e) => this.setState({ car_brand: e.target.value })}>
                                        <option value="">กรุณาเลือก</option>
                                            {
                                            carBrandList.map((item,key) => {
                                                
                                                return(
                                                    // (item.first_name === device_driver) && 
                                                    <option key={key} selected={car_brand == item.name} value={item.name}>{item.name}</option> 
                                                )
                                            })
                                            }
                                        </select> */}
                                            {
                                                console.log('car_brand', car_brand)
                                            }
                                            <Select
                                                placeholder={'กรุณาเลือก'}
                                                // defaultValue={{ label: 'ABG', value: 'ABG' }}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                isDisabled={isDisabled}
                                                isLoading={isLoading}
                                                isClearable={isClearable}
                                                isRtl={isRtl}
                                                isSearchable={isSearchable}
                                                name="color"
                                                options={select}
                                                onChange={this.onSelectCar.bind(this)}
                                                value={this.state.selectedCar}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-md-4  col-form-label ">Chassis</label>
                                        <div className="col-md-8" >
                                            <input
                                                className="form-control"
                                                type="text"
                                                id="userName"
                                                defaultValue={chassis}
                                                onChange={(e) => this.setState({ chassis: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-md-4  col-form-label ">ชื่อผู้ประกอบการ</label>
                                        <div className="col-md-8" >
                                            <input
                                                className="form-control"
                                                type="text"
                                                id="userName"
                                                defaultValue={company}
                                                onChange={(e) => this.setState({ company: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-md-4  col-form-label ">แนบไฟล์</label>
                                        <div className="col-md-8" >
                                            {
                                                this.state.attachDoc != null && this.state.attachDoc != undefined && this.state.attachDoc.length > 0 &&

                                                this.state.attachDoc.map((att, key) => {
                                                    return (
                                                        <div>
                                                            <span>{key + 1}. </span>
                                                            <a href={"http://203.150.199.244/api/admin" + att.img} target="_blank" rel="attach">{this.getBase64(att.name)} </a>
                                                            <input type="button" className="btn btn-sm mt-1" value="X" onClick={() => this.deleteAttachDocument(att.name)} />
                                                        </div>
                                                    )
                                                })
                                            }
                                            <input
                                                type="file"
                                                id="f01"
                                                defaultValue={file_attach}
                                                onChange={(e) => { this.handleFileSelect(e) }}

                                            />
                                            <label for="f01"><i class="fa fa-upload fa-fw"></i> อัพโหลดไฟล์</label>


                                            {/* <input type="button" onClick={() => this.handleUpload()} value="Upload"/>
                                        <i class="far fa-times-circle" style={{color: 'red'}}></i>

                                
                                {/* <span class="btn btn-primary btn-xs">
                                    <span><i class="fa fa-upload fa-fw"></i> อัพโหลดไฟล์</span>
                                    <input type="file" name="attach_file" onChange={(e) => {this.handleFileSelect(e)}}/>
                                </span> */}

                                            {/* <input type="file" name="" id="" onChange={(e) => {this.handleFileSelect(e)}} />
        <input type="button" onClick={() => this.handleUpload()} value="Upload"/>
        <div> {Math.round(this.state.loaded,2) } %</div> */}

                                            {/* <input type="file" id="filePicker" onChange={(e) => {this.handleFileSelect(e)}}/> */}

                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-md-4  col-form-label ">แนบไฟล์หยุดเกิน7วัน</label>
                                        <div className="col-md-8" >
                                            {
                                                this.state.attachOff != null && this.state.attachOff != undefined && this.state.attachOff.length > 0 &&

                                                this.state.attachOff.map((att, key) => {
                                                    return (
                                                        <div>
                                                            <span>{key + 1}. </span>
                                                            <a href={"http://203.150.199.244/api/admin" + att.img} target="_blank" rel="attachOff">{this.getBase64(att.name)} </a>
                                                            <input type="button" className="btn btn-sm mt-1" value="X" onClick={() => this.deleteAttachOffline(att.name)} />
                                                        </div>
                                                    )
                                                })
                                            }
                                            <input
                                                type="file"
                                                id="f02"
                                                defaultValue={file_attach}
                                                onChange={(e) => { this.handleFileSelectOffline(e) }}

                                            />
                                            <label for="f02"><i class="fa fa-upload fa-fw"></i> อัพโหลดไฟล์</label>
                                        </div>
                                    </div>
                                </form>

                            </div>
                            <div className="col-md-6">
                                <form>
                                    <div className="form-group  row">
                                        <label className="col-md-4 col-form-label ">รายละเอียดการแก้ไขเปลี่ยนแปลง</label>
                                        <div className="col-md-8">
                                            <textarea
                                                className="form-control"

                                                id="userName"
                                                value={change_detail}
                                                onChange={(e) => this.setState({ change_detail: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group   row">
                                        <label className="col-md-4  col-form-label ">วันที่แจ้ง</label>
                                        <div className="col-md-8">

                                            <DatePicker className="form-control"
                                                selected={this.state.inform_date}
                                                onChange={this.handleChangeInformlDate}
                                            />
                                        </div>
                                    </div>
                                    <hr />

                                    <div className="form-group  row">
                                        <label className="col-md-4 col-form-label ">สถานที่ซ่อม</label>
                                        <div className="col-md-8">
                                            <textarea
                                                className="form-control"

                                                id="userName"
                                                value={fix_place}
                                                onChange={(e) => this.setState({ fix_place: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group   row">
                                        <label className="col-md-4  col-form-label ">วันที่ซ่อม</label>
                                        <div className="col-md-8">

                                            <DatePicker className="form-control"
                                                selected={this.state.fix_place_start_date}
                                                onChange={this.handleChangeStartDate}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group   row">
                                        <label className="col-md-4  col-form-label ">วันที่เสร็จ</label>
                                        <div className="col-md-8">

                                            <DatePicker className="form-control"
                                                selected={this.state.fix_place_finish_date}
                                                onChange={this.handleChangeFinishDate}
                                            />
                                        </div>
                                    </div>
                                </form>


                            </div>

                        </div>
                        <hr />
                        <div className="text-right">
                            <input type="button" className="btn btn-primary" value="บันทึกข้อมูล" onClick={this.onClickUpdate} />
                        </div>
                    </div>
                </div>

            </div>

        );
    }
}


SpecialConfig.defaultProps = {
    specialSetting: {}
}

SpecialConfig.propTypes = {
    specialSetting: PropTypes.object,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    deviceId: PropTypes.number.isRequired,
    unit_id: PropTypes.string,
}

export default SpecialConfig;


// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/SpecialConfig.js